<b3-drawer
  [open]="isOpen"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes do Crédito de Carbono"
    aria-level="2"
    show-back
    back-aria-label="Fechar detalhes do crédito">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="operation-confirmation-details-drawer" *ngIf="!isLoading && credit; else drawerState">
      <div class="operation-confirmation-details-drawer__badges">
        <b3-tag
          size="sm"
          variant="filled"
          [icon]="typeBadge.icon"
          [tone]="typeBadge.tone"
          [label]="typeBadge.label">
        </b3-tag>
        <b3-tag
          *ngIf="showBrcerBadge"
          size="sm"
          variant="filled"
          tone="info"
          icon="check_circle"
          label="BRCER">
        </b3-tag>
      </div>

      <div class="operation-confirmation-details-drawer__grid operation-confirmation-details-drawer__grid--2">
        <div class="operation-confirmation-details-drawer__field">
          <span class="operation-confirmation-details-drawer__label">Data de emissão</span>
          <span class="operation-confirmation-details-drawer__value">{{ issueDate }}</span>
        </div>
        <div class="operation-confirmation-details-drawer__field">
          <span class="operation-confirmation-details-drawer__label">CPF/CNPJ do Comitente</span>
          <span class="operation-confirmation-details-drawer__value">{{ comitenteDocument }}</span>
        </div>
      </div>

      <div class="operation-confirmation-details-drawer__grid operation-confirmation-details-drawer__grid--2">
        <div class="operation-confirmation-details-drawer__field">
          <span class="operation-confirmation-details-drawer__label">Qtd. Emitida</span>
          <span class="operation-confirmation-details-drawer__value">{{ issuedQuantity }}</span>
        </div>
        <div class="operation-confirmation-details-drawer__field">
          <span class="operation-confirmation-details-drawer__label">Qtd. Atual</span>
          <span class="operation-confirmation-details-drawer__value">{{ currentQuantity }}</span>
        </div>
      </div>

      <div class="operation-confirmation-details-drawer__grid operation-confirmation-details-drawer__grid--2">
        <div class="operation-confirmation-details-drawer__field">
          <span class="operation-confirmation-details-drawer__label">Início da Safra (Vintage)</span>
          <span class="operation-confirmation-details-drawer__value">{{ vintageStart }}</span>
        </div>
        <div class="operation-confirmation-details-drawer__field">
          <span class="operation-confirmation-details-drawer__label">Fim da Safra (Vintage)</span>
          <span class="operation-confirmation-details-drawer__value">{{ vintageEnd }}</span>
        </div>
      </div>

      <div class="operation-confirmation-details-drawer__field operation-confirmation-details-drawer__field--full">
        <span class="operation-confirmation-details-drawer__label">Serial Range</span>
        <span class="operation-confirmation-details-drawer__value">{{ serialRange }}</span>
      </div>

      <div class="operation-confirmation-details-drawer__field operation-confirmation-details-drawer__field--full">
        <span class="operation-confirmation-details-drawer__label">Link do projeto na certificadora</span>
        <a
          *ngIf="hasProjectLink; else projectLinkText"
          class="operation-confirmation-details-drawer__link"
          [href]="projectLink"
          target="_blank"
          rel="noopener noreferrer">
          {{ projectLink }}
        </a>
        <ng-template #projectLinkText>
          <span class="operation-confirmation-details-drawer__value">{{ projectLink }}</span>
        </ng-template>
      </div>

      <div class="operation-confirmation-details-drawer__field operation-confirmation-details-drawer__field--full">
        <span class="operation-confirmation-details-drawer__label">Nome da Certificadora</span>
        <span class="operation-confirmation-details-drawer__value">{{ certifierName }}</span>
      </div>

      <div class="operation-confirmation-details-drawer__field operation-confirmation-details-drawer__field--full">
        <span class="operation-confirmation-details-drawer__label">Descrição adicional</span>
        <p class="operation-confirmation-details-drawer__value operation-confirmation-details-drawer__value--description">
          {{ additionalDescription }}
        </p>
      </div>

      <footer class="operation-confirmation-details-drawer__footer">
        <b3-button
          class="operation-confirmation-details-drawer__confirm-btn"
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="close()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Entendi
        </b3-button>
      </footer>
    </div>

    <ng-template #drawerState>
      <p *ngIf="isLoading" class="operation-confirmation-details-drawer__state">Carregando detalhes do crédito...</p>
      <p *ngIf="!isLoading && loadError" class="operation-confirmation-details-drawer__state">{{ loadError }}</p>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>
